import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../hooks/useApi';
import { Application } from '../../models/application';

export const useApplication = ({
  applicationId,
  sessionId,
}: { applicationId?: string; sessionId?: string | null } = {}) => {
  const { api } = useApi({ throwIfError: true });

  const getApplication = async (
    applicationId?: string,
    sessionId?: string | null
  ): Promise<Application> => {
    return await api({
      route: `/amazon-hbc/application/${applicationId}?session_id=${sessionId}`,
    });
  };

  const {
    data: application,
    isLoading,
    isInitialLoading,
    isError,
  } = useQuery<Application, Error>({
    queryKey: ['application', applicationId, sessionId],
    queryFn: () => getApplication(applicationId, sessionId),
    enabled: !!applicationId && !!sessionId,
    retry: false,
  });

  return { application, isLoading, isError, isInitialLoading };
};
